import {cn} from '@/utils/ui';

import {useCanTrackWorkTime} from '../hooks/useCanTrackWorkTime';
import {useMyWorkTimeStatus} from '../hooks/useMyWorkTimeStatus';

const WorkTimeStatusDot = () => {
  const canTrackWorkTime = useCanTrackWorkTime();
  const {isWorking} = useMyWorkTimeStatus();

  if (!canTrackWorkTime) return null;

  return (
    <span
      className={cn(
        'absolute right-1.5 bottom-1.5 size-2.5 rounded-full ring-2 ring-white',
        isWorking ? 'bg-accent-700' : 'bg-danger-800'
      )}
    />
  );
};

export default WorkTimeStatusDot;
